const FeeGroupEnum = Object.freeze({
    INVESTOR: 'INVESTOR',
    INVESTEE_COMPANY: 'INVESTEE_COMPANY',
    OTHER: 'OTHER'
});

export default FeeGroupEnum;
